import { IErrorResponseType, ISubmitPaymentConsent, ISuccessResponseType } from "../../constants/commonTypes";
import * as TransactionActions from "../actionTypes/transactionActionTypes";
import { TransactionState } from "../reducers/transactionDetailsReducer";

export function getTransactionDetails(): TransactionActions.GetTransactionDetailsAction {
  return {
    type: TransactionActions.GET_TRANSACTION_DETAILS
  };
}

export function getTransactionDetailsRequest(): TransactionActions.GetTransactionDetailsRequestAction {
  return {
    type: TransactionActions.GET_TRANSACTION_DETAILS_REQUEST
  }
}

export function getTransactionDetailsSuccess(response: TransactionState): TransactionActions.GetTransactionDetailsSuccessAction {
  return {
    type: TransactionActions.GET_TRANSACTION_DETAILS_SUCCESS,
    userName: response.userName,
    userDOB: response.userDOB,
    pan: response.pan,
    freezeFlag: response.freezeFlag,
    emailId: response.emailId,
    amount: response.amount,
    currency: response.currency,
    referenceNumber: response.referenceNumber,
    purposeCode: response.purposeCode,
    limit: response.limit,
    partnerName: response.partnerName,
    accNumbers: response.accNumbers,
    transactionDetailsFetched: response.transactionDetailsFetched,
    lastLoginTime: response.lastLoginTime
  }
}

export function getTransactionDetailsFailure(error: Error | string | IErrorResponseType): TransactionActions.GetTransactionDetailsFailureAction {
  return {
    type: TransactionActions.GET_TRANSACTION_DETAILS_FAILURE,
    error
  }
}


export function submitTransactionConsent(request: ISubmitPaymentConsent): TransactionActions.SubmitTransactionConsentAction {
  return {
    type: TransactionActions.SUBMIT_TRANSACTION_CONSENT,
    request
  }
}

export function submitTransactionConsentRequest(): TransactionActions.SubmitTransactionConsentRequestAction {
  return {
    type: TransactionActions.SUBMIT_TRANSACTION_CONSENT_REQUEST
  }
}


export function submitTransactionConsentSuccess(response: ISuccessResponseType): TransactionActions.SubmitTransactionConsentSuccessAction {
  return {
    type: TransactionActions.SUBMIT_TRANSACTION_CONSENT_SUCCESS,
    consentResponse: response
  }
}


export function submitTransactionConsentReset(): TransactionActions.SubmitTransactionConsentResetAction {
  return {
    type: TransactionActions.SUBMIT_TRANSACTION_CONSENT_RESET,
  }
}

export function submitTransactionConsentFailure(error: Error | string | IErrorResponseType): TransactionActions.SubmitTransactionConsentFailureAction {
  return {
    type: TransactionActions.SUBMIT_TRANSACTION_CONSENT_FAILURE,
    error
  }
}


export function getTax(): TransactionActions.GetTaxAction {
  return {
    type: TransactionActions.GET_TAX_DETAILS
  };
}

export function getUpload(): TransactionActions.GetUploadAction {
  return {
    type: TransactionActions.GET_UPLOAD_DETAILS
  };
}

export function getTaxRequest(): TransactionActions.GetTaxRequestAction {
  return {
    type: TransactionActions.GET_TAX_DETAILS_REQUEST
  }
}

export function getTaxSuccess(response: TransactionState): TransactionActions.GetTaxSuccessAction {
  return {
    type: TransactionActions.GET_TAX_DETAILS_SUCCESS,
    response
  }
}

export function getUpdateSuccess(response: TransactionState): TransactionActions.GetUploadSuccessAction {
  return {
    type: TransactionActions.GET_UPDATE_SUCCESS,
    response
  }
}

export function getTaxFailure(error: Error | string | IErrorResponseType): TransactionActions.GetTaxFailureAction {
  return {
    type: TransactionActions.GET_TAX_DETAILS_FAILURE,
    error
  }
}
